import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  // 24h countdown
  const [timeLeft, setTimeLeft] = useState(24 * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor(timeLeft % 3600 / 60);
  const s = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const scrollToOferta = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <button onClick={scrollToOferta} className="fixed top-0 left-0 right-0 z-50 bg-padel-blue/95 backdrop-blur border-b border-neon/30 py-2 px-4 flex items-center justify-center gap-3 text-sm font-medium hover:bg-padel-blue transition-colors" aria-label="La oferta termina pronto, ver oferta" data-id="element-67">
      <Clock className="w-4 h-4 text-neon flex-shrink-0" data-id="element-68" />
      <span className="hidden sm:inline text-gray-200 uppercase tracking-wide font-display" data-id="element-69">
        La oferta termina en
      </span>
      <span className="sm:hidden text-gray-200 uppercase tracking-wide font-display text-xs" data-id="element-70">
        Termina en
      </span>
      <span className="font-display font-bold text-neon tabular-nums tracking-wider" data-id="element-71">
        {pad(h)}:{pad(m)}:{pad(s)}
      </span>
    </button>;
}